import Globals from './Globals'

const HEARTBEAT_INTERVAL = 5 * 60 * 1000; // 5 minutes
// The user object is written asynchronously at boot (login verify, or the
// ?u= share-token verify in Launch.js), so the first beat almost always
// fires before there is a token to send. Poll briefly until one appears
// rather than waiting out a full interval - a share-link visit that lasts
// less than 5 minutes used to be recorded as nothing at all.
const AUTH_WAIT_INTERVAL = 3 * 1000;
const AUTH_WAIT_TIMEOUT = 60 * 1000;
const STORAGE_KEY = 'expo.heartbeat.clientId';

let intervalId = null;
let authWaitId = null;
let authWaitElapsed = 0;
let interacted = false;

function onInteraction() {
    interacted = true;
}

function getClientId() {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
        id = crypto.randomUUID ? crypto.randomUUID() :
            'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
}

function getClientType() {
    if (Globals.instance().electron) return 'desktop';
    if (Globals.instance().ipad || Globals.instance().ios) {
        if (Globals.instance().controllerApp) return 'ipad_controller';
        return 'ipad';
    }
    return 'web';
}

function getStatus() {
    if (Globals.instance().controllerApp) {
        return Globals.instance().nid ? 'controlling' : 'idle';
    }
    if (Globals.instance().presentationMode || Globals.instance().nid) return 'presenting';
    return 'idle';
}

function getToken() {
    var userObj = null;
    try { userObj = JSON.parse(localStorage.getItem('user')); } catch(e) {}
    return userObj ? userObj.token : null;
}

// Returns true once a beat has actually been sent (i.e. there was a token to
// send it with) so the boot-time poll below knows when to stop.
function sendHeartbeat() {
    if (Globals.instance().noInternet) return false;

    var apiBase = Globals.instance().adminAPI;
    if (!apiBase) return false;

    var token = getToken();
    if (!token) return false;

    var headers = { 'Content-Type': 'application/json' };
    headers['Authorization'] = 'Token ' + token;

    var body = {
        client_id: getClientId(),
        client_type: getClientType(),
        version: Globals.instance().build,
        status: getStatus(),
        narrative_id: Globals.instance().nid || null,
        interaction: interacted,
    };
    interacted = false;

    fetch(apiBase + '/api/core/heartbeat/', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body),
    }).then(function() {
        console.log('Heartbeat sent');
    }).catch(function(err) {
        console.warn('Heartbeat failed', err);
    });

    return true;
}

function stopWaitingForAuth() {
    if (!authWaitId) return;
    clearInterval(authWaitId);
    authWaitId = null;
}

// Watch for the user object landing in localStorage, then send the beat the
// boot-time call couldn't. Gives up after AUTH_WAIT_TIMEOUT so a genuinely
// signed-out session doesn't poll forever; the 5 minute interval still runs.
function waitForAuth() {
    if (authWaitId) return;
    authWaitElapsed = 0;
    authWaitId = setInterval(function() {
        authWaitElapsed += AUTH_WAIT_INTERVAL;
        if (sendHeartbeat() || authWaitElapsed >= AUTH_WAIT_TIMEOUT) {
            stopWaitingForAuth();
        }
    }, AUTH_WAIT_INTERVAL);
}

export function startHeartbeat() {
    if (intervalId) return;
    document.addEventListener('click', onInteraction, { passive: true });
    document.addEventListener('touchstart', onInteraction, { passive: true });
    document.addEventListener('keydown', onInteraction, { passive: true });
    if (!sendHeartbeat()) waitForAuth();
    intervalId = setInterval(function() {
        // A later sign-in (or share-link verify) after the poll gave up still
        // gets picked up here.
        sendHeartbeat();
    }, HEARTBEAT_INTERVAL);
}

export default { startHeartbeat };
